module.exports = __webpack_public_path__ + "static/media/new.b755406f.png";